<!-- begin::Header-->
<div class="card-header align-items-center border-0 mt-4">
  <h3 class="card-title align-items-start flex-column">
    <span class="fw-bolder mb-2 text-gray-900">Aktywność bota</span>
    <span class="text-muted fw-bold fs-7">1200 połączeń</span>
  </h3>
  <div class="card-toolbar">
    <!-- begin::Menu-->
    <button
      type="button"
      class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
      data-kt-menu-trigger="click"
      data-kt-menu-placement="bottom-end"
      data-kt-menu-flip="top-end"
    >
      <app-keenicon name="category" class="fs-2"></app-keenicon>
    </button>
    <app-dropdown-menu1></app-dropdown-menu1>
    <!-- end::Menu-->
  </div>
</div>
<!-- end::Header-->
<!-- begin::Body-->
<div class="card-body pt-5">
  <!-- begin::Timeline-->
  <div class="timeline-label">
    <!-- begin::Item-->
    <div class="timeline-item">
      <!-- begin::Label-->
      <div class="timeline-label fw-bolder text-gray-800 fs-6">08:00</div>
      <!-- end::Label-->
      <!-- begin::Badge-->
      <div class="timeline-badge">
        <i class="fa fa-genderless text-success fs-1"></i>
      </div>
      <!-- end::Badge-->
      <!-- begin::Text-->
      <div class="fw-mormal timeline-content text-muted ps-3">
        Start bota
      </div>
      <!-- end::Text-->
    </div>
    <!-- end::Item-->
    <!-- begin::Item-->
    <div class="timeline-item">
      <!-- begin::Label-->
      <div class="timeline-label fw-bolder text-gray-800 fs-6">10:00</div>
      <!-- end::Label-->
      <!-- begin::Badge-->
      <div class="timeline-badge">
        <i class="fa fa-genderless text-warning fs-1"></i>
      </div>
      <!-- end::Badge-->
      <!-- begin::Content-->
      <div class="timeline-content d-flex">
        <span class="fw-bolder text-gray-800 ps-3">Sprawdzenie działania bota</span>
        <a href="#" class="text-primary">Liczba połączeń 500</a>
      </div>
      <!-- end::Content-->
    </div>
    <!-- end::Item-->
    <!-- begin::Item-->
    <div class="timeline-item">
      <!-- begin::Label-->
      <div class="timeline-label fw-bolder text-gray-800 fs-6">12:00</div>
      <!-- end::Label-->
      <!-- begin::Badge-->
      <div class="timeline-badge">
        <i class="fa fa-genderless text-warning fs-1"></i>
      </div>
      <!-- end::Badge-->
      <!-- begin::Desc-->
      <div class="timeline-content fw-bolder text-gray-800 ps-3">
        Sprawdzenie działania bota
        <a href="#" class="text-primary">Liczba połączeń 800</a>
      </div>
      <!-- end::Desc-->
    </div>
    <!-- end::Item-->
    <!-- begin::Item-->
    <div class="timeline-item">
      <!-- begin::Label-->
      <div class="timeline-label fw-bolder text-gray-800 fs-6">18:00</div>
      <!-- end::Label-->
      <!-- begin::Badge-->
      <div class="timeline-badge">
        <i class="fa fa-genderless text-danger fs-1"></i>
      </div>
      <!-- end::Badge-->
      <!-- begin::Text-->
      <div class="timeline-content fw-mormal text-muted ps-3">
        Koniec działania bota
        <a href="#" class="text-primary">Liczba połączeń 1200</a>
      </div>
      <!-- end::Text-->
    </div>
    <!-- end::Item-->
    <!-- begin::Item-->

    <!-- end::Item-->
    <!-- begin::Item-->
  
    <!-- end::Item-->
    <!-- begin::Item-->
   
    <!-- end::Item-->
  </div>
  <!-- end::Timeline-->
</div>
<!-- end: Card Body-->
